import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCustomerServices } from "../services/Services";
import { iconValues } from "../utils/iconsValues";
import { inventoryTypes } from "../utils/inventoryType";


export const TireSearch = () => {
    const navigate = useNavigate();
    const [selectedService, setSelectedService] = useState<number>(0);
    const [servicesOptions, setServicesOptions] = useState<any[]>([]);
    const [serviceOptionsLoaded, setServiceOptionsLoaded] = useState<boolean>(false);
    const [requiresTireCount, setRequiresTireCount] = useState<boolean>(false);
    const [serviceType, setServiceType] = useState<string>("");

    useEffect(() => {
        setServiceOptionsLoaded(false);
        getCustomerServices()
            .then((data) => {
                const serviceData = data.reverse()?.map((option: any) => {
                    return {
                        value: option?.serviceID,
                        label: option?.serviceName,
                        icon: iconValues?.filter((item: any) => item?.value === option.icon)[0]?.icon,
                        requiresTireCount: option?.requiresTireCount,
                        inventoryType: option?.inventoryType
                    }
                })
                setServicesOptions(serviceData)
                setSelectedService(serviceData[0]?.value)
                setRequiresTireCount(serviceData[0]?.requiresTireCount);
                setServiceType(() => serviceData[0]?.inventoryType === inventoryTypes?.find((item: any) => item?.label === "Wheel")?.id ? "Wheel" : serviceData[0]?.inventoryType === inventoryTypes?.find((item: any) => item?.label === "Tire")?.id ? "Tire" : "")
                setServiceOptionsLoaded(true);
            }).catch((error) => {
                setServicesOptions([]);
                console.error(error);
            })
    }, [])


    return (
        <>
            <div className="mt-10 bg-white text-gray-800 rounded-md shadow-lg">

                <div className="flex">
                    <button className="flex-1 py-3 text-lg font-semibold text-primary">
                        SELECT SERVICE
                    </button>
                </div>
                {
                    serviceOptionsLoaded && (
                        <div className="grid grid-cols-2 gap-4 p-6">
                            {servicesOptions.map((opt: any, index: number) => (
                                <button
                                    key={index}
                                    onClick={() => {
                                        setSelectedService(Number(opt?.value))
                                        setRequiresTireCount(opt?.requiresTireCount)
                                        setServiceType(() => opt?.inventoryType === inventoryTypes?.find((item: any) => item?.label === "Wheel")?.id ? "Wheel" : opt?.inventoryType === inventoryTypes?.find((item: any) => item?.label === "Tire")?.id ? "Tire" : "")
                                    }}
                                    className={`flex flex-col items-center border rounded-lg p-4 transition 
                                            ${selectedService === opt.value
                                            ? "border-primary bg-primary/10 shadow-sm"
                                            : "border-gray-300 hover:border-primary hover:bg-primary/5"
                                        }`}
                                >
                                    <span className="w-10 h-10 mb-2">
                                        {opt?.icon}
                                    </span>
                                    <p className="text-sm font-semibold text-gray-800">{opt.label}</p>
                                </button>
                            ))}
                        </div>
                    )
                }

                {
                    !serviceOptionsLoaded && (
                        <div className="flex justify-center items-center py-4">
                            <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full mx-auto" />
                        </div>

                    )
                }


                <div className="w-full p-4">
                    <button className="w-full bg-primary hover:bg-orange-600 text-white text-lg py-3 rounded-[70px] font-medium transition" onClick={() => {
                        if (selectedService) {
                            navigate("/book-service", {
                                state: {
                                    service: selectedService,
                                    requiresTireCount,
                                    serviceType
                                }
                            })
                        }
                    }}>
                        BOOK SERVICE
                    </button>
                </div>

            </div>
        </>
    )
}
